import { type ReactNode, useContext, useEffect } from 'react';
import useStoredBooking from '../../hooks/useStoredBooking';
import { AuthContext } from '../auth';

const BookingProvider = ({ children }: { children: ReactNode }) => {
  const { loggedIn } = useContext(AuthContext);
  const [, , removeBooking] = useStoredBooking();

  useEffect(() => {
    if (!loggedIn) removeBooking();
  }, [loggedIn, removeBooking]);

  return children;
};

export default BookingProvider;
